module.exports = __webpack_public_path__ + "static/img/7.6bc17f1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/4/1/sp/7.png
// module id = 2u5j
// module chunks = 0